import { useEffect } from 'react';

export const useInitAnalitics = ({ userId, userInfoLoaded }) => {
  useEffect(() => {
    window?.newrelic?.addRelease?.(window.TAG_VERSION);
  }, []);

  useEffect(() => {
    if (userInfoLoaded) {
      window.newrelic?.setUserId?.(userId);
    }
  }, [userId, userInfoLoaded]);
};
